export const french = {
  feedback: {
    "title": "Envoyer un avis",
    "category": "Catégorie",
    "suggestion": "Suggestion",
    "problem": "Problème",
    "other": "Autre",
    "message": "Ton avis",
    "placeholder": "Que voudrais-tu améliorer ou qu’est-ce qui n’a pas fonctionné ?",
    "email": "Email de réponse (facultatif)",
    "send": "Envoyer un avis",
    "sending": "Envoi…",
    "success": "Merci — ton avis a été reçu.",
    "error": "Impossible d’envoyer ton avis. Ton texte est conservé ; réessaie.",
    "invalid": "Saisis 10 à 3 000 caractères et un email valide si renseigné.",
    "signIn": "Connecte-toi pour envoyer un avis",
    "inbox": "Avis des utilisateurs",
    "empty": "Aucun avis pour le moment.",
    "reviewed": "Lu",
    "markReviewed": "Marquer comme lu",
    "refresh": "Actualiser",
    "new": "Nouveau"
},
  menu: {
    signOut: "Se Déconnecter",
    signIn: "Se Connecter / S'inscrire",
    talkToUs: "Contactez-nous",
    language: "Langue",
    deleteAccount: "Supprimer le Compte",
    accountSettings: "Paramètres du compte",
  },
  theme: {
    light: "Clair",
    dark: "Sombre",
  },
  landing: {
    heroKicker: "Pour les citoyens et les municipalités du monde entier",
    heroSub: "Nous transmettons votre voix à la municipalité — partout dans le monde.",
    municipalityLogin: "Connexion commune",
    pecCardTitle: "Chaque signalement atteint les municipalités du monde entier",
    pecBadge: "Email",
    pecCardBody: "De n'importe quelle ville, dans n'importe quel pays. Les municipalités partenaires reçoivent les signalements directement; lorsqu'une municipalité n'est pas encore partenaire, nous transmettons chaque signalement aux autorités locales par email, pour qu'aucun problème ne reste invisible.",
    pecTitle: "Chaque signalement compte, même sans partenariat",
    pecBody: "Même si votre municipalité n'est pas encore partenaire de ShapeIt, nous envoyons chaque signalement aux autorités locales par email, pour qu'aucun problème ne reste invisible.",
    pecHighlight: "Nous transmettons les signalements aux municipalités par email",
    ctaSub: "Rejoignez citoyens et municipalités du monde entier et agissez, un signalement à la fois.",
  },
  mapHeader: {
    appName: "Shapeit",
    login: "Se Connecter / S'inscrire",
    searchPlaceholder: "Cherchez un lieu ou cliquez n'importe où sur la carte pour signaler un problème",
    clearSearch: "Effacer la recherche",
  },
  mapLegend: {
    title: "Légende Shapeit",
    buttonLabel: "Légende",
    dirty: "Sale",
    unsafe: "Dangereux",
    needsFix: "À Réparer",
  },
  dialog: {
    selectLanguage: "Sélectionnez votre langue préférée",
    chooseLanguage: "Choisissez une langue pour l'interface de l'application.",
    confirm: "Confirmer",
    welcome: {
      title: "Bienvenue!",
      message: "Shapeit est là pour vous donner du pouvoir, nous voulons que vous puissiez façonner votre ville et la transformer en un endroit meilleur. Chaque fois que vous repérez un problème, vous pouvez le signaler et vous pouvez également aimer les signalements d'autres utilisateurs pour leur donner une plus grande visibilité. De notre côté, nous veillerons à tenir les autorités de la ville au courant des problèmes les plus urgents.",
      message2: "Shapeit travaille à établir des partenariats avec des municipalités du monde entier. Même si votre ville n'est pas encore partenaire, nous envoyons chaque signalement aux autorités locales par email, pour qu'aucun problème ne reste invisible. Chaque signalement contribue à créer une base de données actualisée des problèmes urbains de votre région : plus nous en collectons, plus notre voix sera forte lorsque nous nous adresserons aux autorités locales. Maintenant, allez et faites de votre ville un endroit meilleur!",
      next: "Suivant",
      button: "Commençons!"
    }
  },
  reports: {
    overview: "Aperçu des Signalements",
    trending: "Tendance",
    myReports: "Mes Signalements",
    yourReports: "Vos Signalements",
    recentReports: "Signalements Récents",
    by: "par",
    anonymous: "Anonyme",
  },
  usernameSetup: {
    title: "Choisissez votre nom d'utilisateur",
    description: "Choisissez un nom public affiché sur vos signalements. Vous pourrez le modifier dans les paramètres du compte.",
    placeholder: "Votre nom d'utilisateur",
    save: "Enregistrer",
    saving: "Enregistrement...",
    skip: "Plus tard",
    tooShort: "Le nom d'utilisateur doit contenir au moins 2 caractères",
    noEmail: "Le nom d'utilisateur ne peut pas contenir @",
    success: "Nom d'utilisateur enregistré",
    error: "Impossible d'enregistrer le nom d'utilisateur",
  },
  reportForm: {
    postAnonymously: "Publier anonymement",
    postAnonymouslyHint: "Votre nom ne sera pas affiché sur ce signalement.",
    postingAs: "Publié en tant que",
    title: "Soumettre un Signalement",
    description: "Description",
    uploadPhoto: "Télécharger une Photo",
    takePhoto: "Prendre une Photo",
    changePhoto: "Changer la Photo",
    preview: "Aperçu",
    submit: "Soumettre le Signalement",
    submitting: "Soumission en cours...",
    loginRequired: "Vous devez être connecté pour soumettre un signalement",
    uploadFailed: "Échec lors du téléchargement du signalement",
    photoUploadFailed: "La photo n'a pas pu être envoyée. Votre signalement est toujours là.",
    sendWithoutPhoto: "Envoyer sans photo",
    selectIssue: "Veuillez sélectionner un type de problème",
    selectIssueType: "Sélectionner un type de problème",
    moderationWarning: "Les signalements sont modérés automatiquement. Le contenu offensant, spam ou inapproprié sera rejeté.",
    rejectedContent: "Votre signalement contient du contenu inapproprié et ne peut pas être publié",
    rateLimitExceeded: "Vous avez atteint la limite de 5 signalements par heure. Réessayez plus tard.",
    characterLimit: "La description ne peut pas dépasser 500 caractères",
    appealLink: "Soumettre un appel par e-mail",
    offensiveContent: "Votre message contient un langage inapproprié",
    validatingImage: "Vérification de l'image en cours...",
        aiAnalyzing: "L'IA analyse...",
    duplicateWarning: "Un rapport similaire existe déjà à proximité. Envisagez de le voter au lieu de créer un doublon.",
    aiSuggestions: "Suggestions IA",
    suggestedTitle: "Titre suggéré :",
    priority: "Priorité :",
    inappropriateImage: "L'image contient du contenu inapproprié et ne peut pas être utilisée",
    notRelevantImage: "La photo ne semble pas montrer un problème urbain. Veuillez télécharger une photo du problème que vous souhaitez signaler.",
  },
  confirmReport: {
    question: "Voulez-vous créer un signalement ici?",
    yes: "Oui",
    no: "Non"
  },
  locationPrompt: "Cliquez sur l'endroit souhaité pour signaler un problème",
  reportHere: "Signaler ici",
  deleteAccount: {
    title: "Supprimer le Compte",
    warning: "Cette action est irréversible !",
    description: "Toutes vos données seront définitivement supprimées, y compris :",
    items: {
      reports: "Tous vos signalements",
      photos: "Toutes les photos téléchargées",
      accountData: "Les informations de votre compte"
    },
    confirmLabel: "Tapez DELETE pour confirmer",
    confirmPlaceholder: "DELETE",
    cancel: "Annuler",
    deleteButton: "Supprimer Mon Compte",
    deleting: "Suppression en cours...",
    success: "Compte supprimé avec succès",
    error: "Échec de la suppression du compte"
  },
  gamification: {
    totalReports: "Signalements totaux",
    congratulations: "Félicitations !",
    pointsEarned: "Points gagnés",
    totalPoints: "Points totaux",
    currentLevel: "Niveau actuel",
    levelUp: "Nouveau niveau !",
    nextLevel: "Prochain niveau",
    progress: "Progrès",
    thankYou: "Merci de rendre la ville meilleure !",
    keepGoing: "Continuez à signaler pour atteindre le prochain niveau !",
    continue: "Continuer",
    levels: {
      beginner: "Débutant",
      active_citizen: "Citoyen actif",
      urban_observer: "Observateur urbain",
      city_guardian: "Gardien de la ville",
      civic_champion: "Champion civique",
      urban_hero: "Héros urbain"
    },
    messages: {
      beginner: "Bienvenue dans la communauté !",
      active_citizen: "Vous faites la différence !",
      urban_observer: "Vos yeux rendent la ville meilleure !",
      city_guardian: "Vous êtes un vrai gardien !",
      civic_champion: "Champion du devoir civique !",
      urban_hero: "Vous êtes un héros urbain !"
    }
  },
  onboarding: {
    step1: {
      title: "Bienvenue sur la Carte !",
      description: "Ici vous pouvez voir tous les signalements de votre communauté. Apprenons comment l'utiliser !"
    },
    step2: {
      title: "Créer un Signalement",
      description: "Recherchez un lieu ou cliquez sur la carte pour créer un nouveau signalement sur un problème dans votre région."
    },
    step3: {
      title: "Types de Signalement",
      description: "Les différentes couleurs représentent différents types de problèmes. Cliquez sur les marqueurs pour voir les détails et voter pour les signalements qui vous intéressent !"
    },
    step4: {
      title: "Votre Profil et Gamification",
      description: "Gagnez des points en créant des signalements et en aidant votre communauté ! Suivez votre niveau et vos progrès ici."
    },
    step5: {
      title: "Vous êtes Prêt !",
      description: "Commencez à améliorer votre communauté en signalant des problèmes et en interagissant avec d'autres signalements. Chaque contribution compte !"
    },
    previous: "Précédent",
    next: "Suivant"
  },
    accountSettings: {
    title: "Paramètres du compte",
    openSettings: "Paramètres du compte",
    changeEmail: "Changer l'email",
    newEmailLabel: "Nouvelle adresse email",
    newEmailPlaceholder: "nouveau@email.com",
    changePassword: "Changer le mot de passe",
    newPasswordLabel: "Nouveau mot de passe",
    newPasswordPlaceholder: "Au moins 6 caractères",
    passwordTooShort: "Le mot de passe doit comporter au moins 6 caractères",
    passwordSuccess: "Mot de passe mis à jour avec succès",
    changeUsername: "Changer le nom d'utilisateur",
    newUsernameLabel: "Nouveau nom d'utilisateur",
    newUsernamePlaceholder: "Votre nom d'utilisateur",
    usernameTooShort: "Le nom d'utilisateur doit comporter au moins 2 caractères",
    usernameSuccess: "Nom d'utilisateur mis à jour avec succès",
    deleteAccountTitle: "Supprimer le compte",
    deleteAccountDescription: "Supprimez définitivement votre compte et toutes les données associées. Cette action est irréversible.",
    deleteAccountButton: "Supprimer le compte",
    save: "Enregistrer",
    saving: "Enregistrement...",
    submit: "Envoyer l'email de confirmation",
    submitting: "Envoi en cours...",
    invalidEmail: "Adresse email invalide",
    error: "Erreur",
    updateFailed: "Mise à jour impossible",
    successTitle: "Email de vérification envoyé",
    successDescription: "Nous avons envoyé un email de confirmation à {email}. Vérifiez votre boîte de réception pour confirmer le changement.",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
  },
  push: {
    title: "Notifications push",
    subtitle: "Gérez les notifications reçues sur votre appareil",
    enable: "Activer les notifications push",
    denied: "Autorisation refusée. Activez les notifications dans les réglages de l'appareil.",
    registered: "Appareil enregistré",
    requestPermission: "Demander l'autorisation de recevoir des notifications",
    resolved: "Signalement résolu",
    resolvedDesc: "Quand un de vos signalements est résolu",
    upvotes: "Votes reçus",
    upvotesDesc: "Quand quelqu'un soutient vos signalements",
    achievements: "Succès débloqués",
    achievementsDesc: "Quand vous débloquez un nouveau succès",
    newReports: "Nouveaux signalements",
    newReportsDesc: "Quand de nouveaux signalements sont créés",
    updated: "Préférences mises à jour",
    updateError: "Impossible de mettre à jour les préférences",
    mobileOnly: "Les notifications push sont envoyées via l'application mobile",
  },
  referral: {
    inviteTitle: "Invitez des amis et gagnez des points !",
    inviteSubtitle: "Créez votre code d'invitation et gagnez 50 points pour chaque ami inscrit.",
    createCode: "Créer un code d'invitation",
    yourCode: "Votre code d'invitation",
    copy: "Copier",
    codeCopied: "Code copié dans le presse-papiers !",
    linkCopied: "Lien d'invitation copié !",
    directLink: "Lien direct",
    stats: "Statistiques d'invitation",
    completed: "Terminées",
    pending: "En attente",
    total: "Total",
    ambassadorProgress: "Progression Ambassadeur",
    ambassadorUnlocked: "Vous avez débloqué le badge Ambassadeur !",
    shareText: "Rejoignez ShapeIt et aidez à améliorer votre ville ! Utilisez mon code {code} pour recevoir 50 points bonus 🎁",
    shareTitle: "Invitation ShapeIt",
  },
  misc: {
    mapLoadFailed: "Impossible de charger la carte",
    mapKeyError: "Impossible de charger la clé API Google Maps",
    mapKeyMissing: "Clé API Google Maps non configurée",
    mapsLoadError: "Impossible de charger Google Maps",
    onlyImages: "Seules les images JPEG, PNG et WebP sont autorisées",
    imageTooLarge: "L'image doit faire moins de 5 Mo",
    photoFailed: "Impossible de prendre la photo",
    current: "Actuel",
    progress: "Progression",
  },
  common: {
    share: "Partager",
    shareTitle: "Partager ce signalement",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié dans le presse-papiers !",
    copyFailed: "Échec de la copie du lien",
    loading: "Chargement...",
    close: "Fermer",
    delete: "Supprimer",
    cancel: "Annuler",
    retry: "Réessayer",
    login: "Connexion",
    register: "S'inscrire",
    email: "E-mail",
    password: "Mot de passe",
    username: "Nom d'utilisateur",
    anonymous: "Anonyme",
    notYourReport: "Ce n'est pas votre signalement",
    loginToDelete: "Connectez-vous pour supprimer",
    upvotes: "Votes",
    reportedBy: "Signalé par",
    trending: "Tendance",
    trendingReports: "Signalements en tendance",
    noTrending: "Aucun signalement en tendance",
    yourReports: "Vos signalements",
    noReportsYet: "Vous n'avez pas encore créé de signalement",
    loadingAddress: "Chargement de l'adresse…",
    myLocation: "Ma position",
    yourLocation: "Votre position",
    mapView: "Vue carte",
    satelliteView: "Vue satellite",
    changePhoto: "Changer la photo",
    uploadingPhoto: "Téléchargement...",
    photoUpdated: "Photo de profil mise à jour",
    photoUploadError: "Impossible de charger la photo",
    removePhoto: "Supprimer la photo",
    inviteFriends: "Inviter des amis",
    achievements: "Réalisations",
    noAchievements: "Aucune réalisation débloquée",
    statusHistory: "Historique du statut",
    seeTranslation: "Voir la traduction",
    seeOriginal: "Voir l'original",
    translating: "Traduction en cours...",
    translationFailed: "Traduction indisponible",
    translatedAutomatically: "Traduit automatiquement",
    deleteConfirm: "Voulez-vous supprimer ce signalement ?",
    loginToDeleteReports: "Connectez-vous pour supprimer des signalements",
    onlyOwnReports: "Vous ne pouvez supprimer que vos propres signalements",
  },
  auth: {
    backToMap: "Retour à la carte",
    subtitle: "Connectez-vous ou créez un compte pour signaler des problèmes dans votre commune",
    login: "Connexion",
    register: "S'inscrire",
    email: "E-mail",
    password: "Mot de passe",
    username: "Nom d'utilisateur",
    orContinueWith: "Ou continuer avec",
    signInGoogle: "Se connecter avec Google",
    signUpGoogle: "S'inscrire avec Google",
    signingIn: "Connexion en cours...",
    signIn: "Se connecter",
    referralLabel: "Code d'invitation (facultatif) 🎁",
    referralPlaceholder: "Saisissez un code d'invitation",
    referralBonus: "Vous recevrez 50 points bonus avec ce code ! 🎁",
    creatingAccount: "Création du compte...",
    createAccount: "Créer un compte",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
  },
  analytics: {
    otherCategory: "Autre",
    pageTitle: "Tableau de bord Analytics",
    pageSubtitle: "Statistiques publiques et transparence sur les signalements de la communauté",
    backToMap: "Retour à la carte",
    noData: "Aucune donnée disponible",
    communityTitle: "Analytics de la communauté",
    communitySubtitle: "Statistiques en temps réel des signalements citoyens",
    municipalityScopedSubtitle: "Statistiques en temps réel des signalements de votre commune",
    totalReports: "Signalements totaux",
    inProgress: "En cours",
    resolved: "Résolus",
    avgTime: "Temps moyen",
    categoryTitle: "Répartition par catégorie",
    categoryDesc: "Types de signalements reçus",
    trendTitle: "Tendance des 7 derniers jours",
    trendDesc: "Nombre de signalements quotidiens",
    topAreasTitle: "Zones les plus signalées",
    topAreasDesc: "Les zones avec le plus de signalements actifs",
    adminTitle: "Analytics avancés (Admin)",
    adminSubtitle: "Métriques détaillées visibles uniquement par les administrateurs",
    dau: "Utilisateurs actifs quotidiens",
    wau: "Utilisateurs actifs hebdomadaires",
    mau: "Utilisateurs actifs mensuels",
    avgSession: "Durée moyenne de session",
    minutesShort: "min",
    mapInteractions: "Interactions avec la carte",
    perSession: "Moyenne par session",
    reportsPerUser: "Signalements par utilisateur",
    average: "Moyenne",
    completionRate: "Taux de complétion",
    loginToReport: "Connexion → Signalement",
    funnelTitle: "Entonnoir de conversion",
    funnelDesc: "Analyse du parcours utilisateur (7 derniers jours)",
    users: "Utilisateurs",
    conversionPct: "% Conversion",
    devicesTitle: "Répartition des appareils",
    devicesDesc: "Analyse des appareils utilisés",
  },
};
